import styles from "gui/TeamPage/TeamStats/TeamStats.module.css";
import { Icon } from "gui/icon/icon";
import { formatNumber } from "lib/intl/number";
import { Member } from "gui/TeamPage/fetchStaticTeamProfileData";

interface Props {
  dashboardsCount: number;
  queriesCount: number;
  people: Member[];
  receivedStarsCount?: number;
}

export default function TeamStats(props: Props) {
  return (
    <ul className={styles.rightList}>
      <li>
        <span>
          {formatNumber(props.receivedStarsCount ?? 0)}{" "}
          {props.receivedStarsCount === 1 ? "star" : "stars"}
        </span>
        <Icon icon="star-fill" aria-hidden />
      </li>
      <li>
        <span>
          {formatNumber(props.queriesCount)}{" "}
          {props.queriesCount === 1 ? "query" : "queries"}
        </span>
        <Icon icon="terminal" aria-hidden />
      </li>
      <li>
        <span>
          {formatNumber(props.dashboardsCount)}{" "}
          {props.dashboardsCount === 1 ? "dashboard" : "dashboards"}
        </span>
        <Icon icon="dashboard" aria-hidden />
      </li>
      {props.people.length > 0 && (
        <li>
          <span>
            {formatNumber(props.people.length ?? 0)}{" "}
            {props.people.length === 1 ? "person" : "people"}
          </span>
          <Icon icon="people" aria-hidden />
        </li>
      )}
    </ul>
  );
}
